module.exports = __webpack_public_path__ + "static/coworking-b0fdc576f85325bc7f07888c07972bc7.jpg";